export const UserNotExist = () => <div className="container text-center">
    <h1 className="display-1 mt-4 pt-4 text-muted" ><i className="fa-solid fa-tooth"></i></h1>
    <h3>This user does not exist</h3>
</div>